module.exports = __webpack_public_path__ + "img/slidebar-bg.de49c424.png";